<template>
  <div class="qrCode" style="padding:0 10px;">
    <van-form>
      <van-field v-model="track" name="url" label="渠道唯一标识" placeholder="渠道唯一标识" :rules="[{ required: true, message: '请填写渠道唯一标识' }]" />
    </van-form>
    <div v-if="qrCodeUrl">
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
        小程序码
      </van-divider>
      <img :src="qrCodeUrl" alt="小程序二维码" style="width:300px;height:300px">
      <van-button round block type="info" style="margin-top:20px;" @click="downLoadFile(qrCodeUrl)">下载高清码</van-button>
    </div>

    <van-button round block type="info" style="margin-top:20px;" @click="generateQrCode()">生成小程序码</van-button>

  </div>
</template>


<script>
import { upLoadFile, generateQRCode } from '@/api/customPageApi.js'
import { GetQueryString } from '@/utils/utils'
export default {
  name: 'fileQrCode',
  data() {
    return {
      fileList: [],
      track: '',
      file: '',
      qrCodeUrl: null,
    }
  },
  created() {
    this.track = GetQueryString('track')
  },
  methods: {
    onSubmit() {},
    downLoadFile(url, fileName) {
      let xhr = new XMLHttpRequest()
      var _this = this
      xhr.open('get', url, true)
      //  xhr.setRequestHeader('Content-Type', `application/${type}`);
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (this.status == 200) {
          //接受二进制文件流
          console.log(this)
          var blob = this.response
          const blobUrl = window.URL.createObjectURL(blob)
          // 这里的文件名根据实际情况从响应头或者url里获取
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = `渠道_${_this.track}高清码`
          a.click()
          window.URL.revokeObjectURL(blobUrl)
        }
      }
      xhr.send()
    },

    async generateQrCode() {
      if (!this.track) {
        this.qrCodeUrl = ''
        return false
      }
      var headerClientInfo = { language: 'CN', eventKey: 'GDTE_2022', appKey: 'WX_MINI_GDTE' }
      let headers1 = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      }
      let paramsKey = {
        track: this.track,
        type: 'channelRegister',
      }

      console.log(paramsKey)
      let params = {
        appKey: 'WX_MINI_GDTE',
        autoColor: true,
        b: 0,
        env: '',
        g: 0,
        jumpPath: '',
        jumpType: '',
        logo: '',
        params: JSON.stringify(paramsKey),
        path: 'pages/index/index',
        r: 0,
        scenesType: 'SUPPER_SCENES_TYPE',
        width: 1280,
      }
      generateQRCode(headers1, params).then((res) => {
        console.log(res)
        this.qrCodeUrl = res.data.value
      })
    },
  },
}
</script>


<style lang="less">
.qrCode {
  max-width: 800px;
  margin: 0 auto;
  .van-uploader__file {
    width: auto;
  }
}
</style>